var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiveChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18.043,
    viewBox: "0 0 19 18.043",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1249",
    "data-name": "Group 1249",
    transform: "translate(-1085.463 -1612.145)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2214",
    "data-name": "Group 2214"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2684",
    "data-name": "Path 2684",
    d: "M1188.15,1578.1h-13.316c-1.292,0-2.342,1.767-2.342,3.939v5.1c0,2.172,1.051,3.939,2.342,3.939h9.089l1.951,3.889a.279.279,0,0,0,.231.181.176.176,0,0,0,.041,0,.375.375,0,0,0,.234-.292l1.031-3.774h.739c1.292,0,2.342-1.767,2.342-3.939v-5.1C1190.492,1579.864,1189.441,1578.1,1188.15,1578.1Zm1.737,9.034c0,1.611-.779,2.922-1.737,2.922h-.933c-.118,0-.225.115-.275.3l-.913,3.342-1.735-3.457a.278.278,0,0,0-.231-.181h-9.229c-.958,0-1.737-1.311-1.737-2.922v-5.1c0-1.611.779-2.922,1.737-2.922h13.316c.958,0,1.737,1.31,1.737,2.922Z",
    transform: "translate(-86.529 34.548)",
    fill: "#141b23",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2213",
    "data-name": "Group 2213",
    transform: "translate(1093 1243.816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "list_FILL0_wght400_GRAD0_opsz48",
    d: "M126.884,380.7V379.47h11.839V380.7H126.884Zm0-3.47V376h11.839v1.225Z",
    transform: "translate(-130.842 -3.15)",
    fill: "#5d5b5c"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveChat);
export default __webpack_public_path__ + "static/media/live_chat.707a058e6c75b25f0f94006bf2f5ad06.svg";
export { ForwardRef as ReactComponent };